import { z } from 'zod';
export const medicationTeachingSchema = z.object({
    id: z.string().optional(),
    medicationId: z.string().min(1, 'required'),
    type: z.string().min(1, 'required'),
    date: z.string().date(),
    notes: z.string().nullish(),
});
